import { useMemo, useRef, useState } from "react";
import { Card, DatePicker, Space } from "antd";
import {
  CommentOutlined,
  DownloadOutlined,
  GroupOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
// import { themeQuartz } from "ag-grid-community";
import { MyText } from "Components/MyText/MyText";
import { MySelect } from "Components/MySelect/MySelect";
import "./styles.css";
import { useSelector } from "react-redux";
import { selectProject } from "AppStore/Slices/ProjectSlice/ProjectSlice";
import { defaultSettings } from "css/defaultAntStyles";
import { exportToExcel } from "./helpers/exportToExcel";
import { MyBtn } from "Components/MyBtn/MyBtn";
import { CommentTooltip } from "Pages/MyProjectPage/helpers/CommentTooltipForTable";
import { myTheme } from "Pages/MyProjectPage/helpers/AGTableStyles/MyTheme";

ModuleRegistry.registerModules([AllCommunityModule]);

export const TableWrapper = ({
  projectTitle = "myProject",
  disabled = false,
  monthNumber,
  setMonthNumber,
}) => {
  const gridRef = useRef();
  const { projectWorksForTable } = useSelector(selectProject);
  const [checkedPeriod, setCheckedPeriod] = useState(null);

  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedWorks, setSelectedWorks] = useState([]);

  // const [projectWorksForTable] = useState([
  //   {
  //     id: 1,
  //     group: "Земляні роботи",
  //     work: "Розкопка траншеї",
  //     plan: 100,
  //     percent: 35,
  //     fact: 35,
  //     "2026-05-01": 5,
  //     "2026-05-02": 10,
  //     "2026-05-03": 20,
  //   },
  //   {
  //     id: 2,
  //     group: "Монтаж",
  //     work: "Прокладка кабелю",
  //     plan: 250,
  //     percent: 12,
  //     fact: 30,
  //     "2026-05-01": 10,
  //     "2026-05-02": 20,
  //   },
  //   {
  //     id: 3,
  //     group: "Монтаж",
  //     work: "Монтаж щита",
  //     plan: 150,
  //     percent: 50,
  //     fact: 75,
  //     "2026-05-04": 15,
  //     "2026-05-05": 20,
  //   },
  //   {
  //     id: 4,
  //     group: "Пусконаладка",
  //     work: "Тестування системи",
  //     plan: 80,
  //     percent: 25,
  //     fact: 20,
  //     "2026-05-06": 5,
  //   },
  //   {
  //     id: 5,
  //     group: "Пусконаладка",
  //     work: "Тестування системи",
  //     plan: 80,
  //     percent: 25,
  //     fact: 20,
  //     "2026-05-06": 5,
  //   },
  //   {
  //     id: 6,
  //     group: "Пусконаладка",
  //     work: "Тестування системи",
  //     plan: 80,
  //     percent: 25,
  //     fact: 20,
  //     "2026-05-06": 5,
  //   },
  //   {
  //     id: 7,
  //     group: "Пусконаладка",
  //     work: "Тестування системи",
  //     plan: 80,
  //     percent: 25,
  //     fact: 20,
  //     "2026-05-06": 5,
  //   },
  //   {
  //     id: 8,
  //     group: "Пусконаладка",
  //     work: "Тестування системи",
  //     plan: 80,
  //     percent: 25,
  //     fact: 20,
  //     "2026-05-06": 5,
  //   },
  //   {
  //     id: 9,
  //     group: "Пусконаладка",
  //     work: "Тестування системи",
  //     plan: 80,
  //     percent: 25,
  //     fact: 20,
  //     "2026-05-06": 5,
  //   },
  //   {
  //     id: 10,
  //     group: "Пусконаладка",
  //     work: "Тестування системи",
  //     plan: 80,
  //     percent: 25,
  //     fact: 20,
  //     "2026-05-06": 5,
  //   },
  //   {
  //     id: 11,
  //     group: "Пусконаладка",
  //     work: "Тестування системи",
  //     plan: 80,
  //     percent: 25,
  //     fact: 20,
  //     "2026-05-06": 5,
  //   },
  //   {
  //     id: 12,
  //     group: "Пусконаладка",
  //     work: "Тестування системи",
  //     plan: 80,
  //     percent: 25,
  //     fact: 20,
  //     "2026-05-06": 5,
  //   },
  //   {
  //     id: 13,
  //     group: "Пусконаладка",
  //     work: "Тестування системи",
  //     plan: 80,
  //     percent: 25,
  //     fact: 20,
  //     "2026-05-06": 5,
  //   },
  //   {
  //     id: 14,
  //     group: "Пусконаладка",
  //     work: "Тестування системи",
  //     plan: 80,
  //     percent: 25,
  //     fact: 20,
  //     "2026-05-06": 5,
  //   },
  //   {
  //     id: 15,
  //     group: "Пусконаладка",
  //     work: "Тестування системи",
  //     plan: 80,
  //     percent: 25,
  //     fact: 20,
  //     "2026-05-06": 5,
  //   },
  //   {
  //     id: 16,
  //     group: "Пусконаладка",
  //     work: "Тестування системи",
  //     plan: 80,
  //     percent: 25,
  //     fact: 20,
  //     "2026-05-06": 5,
  //   },
  //   {
  //     id: 17,
  //     group: "Пусконаладка",
  //     work: "Тестування системи",
  //     plan: 80,
  //     percent: 25,
  //     fact: 20,
  //     "2026-05-06": 5,
  //   },
  // ]);

  const groupOptions = useMemo(() => {
    return [...new Set(projectWorksForTable.map((i) => i.group))].map(
      (group) => ({
        label: group,
        value: group,
      }),
    );
  }, [projectWorksForTable]);

  const workOptions = useMemo(() => {
    return [...new Set(projectWorksForTable.map((i) => i.work))].map(
      (work) => ({
        label: work,
        value: work,
      }),
    );
  }, [projectWorksForTable]);

  const filteredData = useMemo(() => {
    return projectWorksForTable.filter((item) => {
      const groupMatch =
        selectedGroups.length === 0 || selectedGroups.includes(item.group);

      const workMatch =
        selectedWorks.length === 0 || selectedWorks.includes(item.work);

      return groupMatch && workMatch;
    });
  }, [projectWorksForTable, selectedGroups, selectedWorks]);

  const dateColumns = useMemo(() => {
    const startDate = checkedPeriod?.[0];
    const endDate = checkedPeriod?.[1];

    if (!startDate || !endDate) return [];

    const cols = [];

    let current = startDate.startOf("day");
    const last = endDate.startOf("day");

    while (current.isBefore(last) || current.isSame(last)) {
      const year = current.year();
      const month = current.month() + 1;
      const day = current.date();

      const fullDate = `${year}-${String(month).padStart(2, "0")}-${String(
        day,
      ).padStart(2, "0")}`;
      const fullDateCorrectVisualization = `${String(day).padStart(
        2,
        "0",
      )}.${String(month).padStart(2, "0")}.${year}`;

      cols.push({
        field: fullDate,
        // headerName: String(day).padStart(2, "0"),
        headerName: fullDateCorrectVisualization,
        width: 105,
        editable: false,
        sortable: false,
        filter: false,
        floatingFilter: false,
        valueGetter: (params) => {
          return params.data?.[fullDate]?.value ?? null;
        },
        tooltipComponent: CommentTooltip,
        tooltipValueGetter: (params) => {
          return params.data?.[fullDate]?.comment ?? "";
        },

        cellRenderer: (params) => {
          const cell = params.data?.[fullDate];

          if (!cell) return null;

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 4,
                width: "100%",
              }}
            >
              <span>{cell.value}</span>

              {cell.comment && (
                <CommentOutlined
                  style={{
                    color: defaultSettings.colorPrimary,
                    fontSize: 12,
                  }}
                />
              )}
            </div>
          );
        },

        cellStyle: {
          textAlign: "center",
          cursor: "pointer",
        },
      });

      current = current.add(1, "day");
    }

    return cols;
  }, [checkedPeriod]);

  const columnDefs = useMemo(() => {
    return [
      {
        field: "group",
        headerName: "Група",
        pinned: "left",
        width: 180,

        sortable: true,
      },

      {
        field: "work",
        headerName: "Назва роботи",
        pinned: "left",
        width: 240,

        sortable: true,
      },
      {
        field: "percent",
        headerName: "% Виконання",
        pinned: "left",
        width: 140,

        sortable: true,

        cellStyle: {
          textAlign: "right",
        },
      },
      {
        field: "plan",
        headerName: "План",
        pinned: "left",
        width: 120,

        sortable: true,

        cellStyle: {
          textAlign: "right",
        },
      },

      {
        field: "fact",
        headerName: "Факт",
        pinned: "left",
        width: 120,

        sortable: true,

        cellStyle: {
          textAlign: "right",
        },
      },

      ...dateColumns,
    ];
  }, [dateColumns]);

  return (
    <div>
      <Card style={{ borderRadius: 16, marginBottom: 16 }}>
        <Space wrap style={{ display: "flex" }}>
          <Space>
            <MyText text={"Період"} />

            <DatePicker.RangePicker
              format="DD.MM.YYYY"
              onChange={setCheckedPeriod}
            />
          </Space>

          <Space>
            <MyText text={"Групи"} />
            <MySelect
              prefix={<GroupOutlined />}
              mode="multiple"
              placeholder="Фільтр по групам"
              width={280}
              options={groupOptions}
              value={selectedGroups}
              handleChange={setSelectedGroups}
            />
          </Space>

          <Space>
            <MyText text={"Роботи"} />
            <MySelect
              prefix={<UnorderedListOutlined />}
              mode="multiple"
              placeholder="Фільтр по роботам"
              width={280}
              options={workOptions}
              value={selectedWorks}
              handleChange={setSelectedWorks}
            />
          </Space>
          {checkedPeriod && (
            <Space>
              <MyBtn
                icon={<DownloadOutlined />}
                onClick={() => exportToExcel(gridRef, projectTitle)}
                text={"Завантажити таблицю"}
              />
            </Space>
          )}
        </Space>
      </Card>

      <div
        style={{
          width: "100%",
        }}
      >
        <AgGridReact
          ref={gridRef}
          theme={myTheme}
          rowData={filteredData}
          columnDefs={columnDefs}
          animateRows
          domLayout="autoHeight"
          rowSelection="multiple"
          suppressMovableColumns
          tooltipShowDelay={0}
          tooltipHideDelay={3000}
          getRowId={(params) => String(params.data.id)}
          defaultColDef={{
            resizable: true,
          }}
          rowClassRules={{
            "row-not-planned": (params) => params.data?.notPlanned === true,
          }}
        />
      </div>
    </div>
  );
};
